import React from 'react';

interface IconProps {
    color?: string;  // Cor do ícone
    height?: string; // Altura do ícone
}

const MapsIcon: React.FC<IconProps> = ({ color = "#000000", height = "192" }) => (
    <svg
        fill="none"
        height={height}
        viewBox="0 0 192 192"
        width={height}
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke={color} strokeWidth="12">
            <path
                d="m96 22a51.88 51.88 0 0 0 -36.77 15.303 52.368 52.368 0 0 0 -15.23 36.943c0 16.596 4.296 28.669 20.811 48.898a163.733 163.733 0 0 1 20.053 28.38c5.988 12.197 5.282 20.476 11.136 20.476s5.148-8.279 11.136-20.476a163.723 163.723 0 0 1 20.053-28.38c16.515-20.229 20.811-32.303 20.811-48.898a52.37 52.37 0 0 0 -15.23-36.943 51.88 51.88 0 0 0 -36.77-15.303z"
            />
            <circle cx="96" cy="74" r="20" />
        </g>
    </svg>
);

export default MapsIcon;
